
import type MenuItem from './types';
import Branding from './Branding.vue';
import MainMenu from './MainMenu.vue';
import type {PropType} from 'vue';
import {defineComponent} from 'vue';
// import Icon from '@/components/Icon/Icon.vue';
import Icon from '../Icon/Icon.vue';

export default defineComponent({
  name: 'OxdSidePanel',

  components: {
    'oxd-icon': Icon,
    'oxd-branding': Branding,
    'oxd-main-menu': MainMenu,
  },

  props: {
    toggle: {
      type: Boolean,
      required: false,
      default: false,
    },
    brandLogoSrc: {
      type: String,
      required: false,
      default: '',
    },
    brandBannerSrc: {
      type: String,
      required: false,
      default: '',
    },
    homeUrl: {
      type: String,
      required: false,
      default: '/',
    },
    menuItems: {
      type: Array as PropType<MenuItem[]>,
      required: false,
      default: () => [],
    },
  },

  emits: ['collapse'],

  computed: {
    classes(): object {
      return {
        toggled: this.toggle,
      };
    },
  },
});
